"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const BannerIcon = () => /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 888"
}, /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  d: "M248.701 749.415c-1.801.139-3.825.111-5.682.638-14.8 4.16-23.226 19.965-19.013 34.717 4.158 14.752 19.402 23.126 34.23 18.939a27.441 27.441 0 0016.626-13.081 27.463 27.463 0 002.387-21.026c-3.494-12.67-15.445-21.109-28.548-20.159v-.028zM27.708 87.118v713.674c0 32.694 23.452 59.41 52.313 59.41h339.958c28.973 0 52.313-26.489 52.313-59.41V87.118c0-32.695-23.452-59.41-52.313-59.41H80.021c-28.973 0-52.313 26.488-52.313 59.41zM0 88.79C0 39.77 35.143 0 78.929 0H421.07C464.643 0 500 39.882 500 88.79v710.328c0 49.02-35.143 88.791-78.929 88.791H78.93C35.357 887.91 0 848.027 0 799.12V88.79zm27.708 577.456h444.584v27.708H27.708v-27.708zM83.123 500h333.754v138.539H83.123V500z"
}));

var _default = BannerIcon;
exports.default = _default;